import { ref } from 'vue';

export type SnackbarConfig = {
  title: string;
  description?: string;
  type: 'success' | 'info';
};

const isSnackbarShown = ref(false);
const snackbarConfig = ref<SnackbarConfig>();

export function useSnackbar() {
  const showSnackbar = (payload: SnackbarConfig) => {
    snackbarConfig.value = payload;

    isSnackbarShown.value = true;
  };

  return {
    snackbarConfig,
    isSnackbarShown,

    showSnackbar,
  };
}
